






class ExportLockManager {
  locks = new Map();

  tryAcquire(key, exportId) {
    if (this.locks.has(key)) {
      return false;
    }

    this.locks.set(key, { exportId, startedAt: Date.now() });
    return true;
  }

  release(key, exportId) {
    const current = this.locks.get(key);
    if (current?.exportId === exportId) {
      this.locks.delete(key);
    }
  }

  isLocked(key) {
    return this.locks.has(key);
  }

  cleanupStale(maxAgeMs) {
    const now = Date.now();
    for (const [key, lock] of this.locks) {
      if (now - lock.startedAt > maxAgeMs) {
        this.locks.delete(key);
      }
    }
  }

  clear() {
    this.locks.clear();
  }
}

export const exportLockManager = new ExportLockManager();

export function buildExportLockKey(context) {
  const tool = context.toolId ?? "unknown";
  const contentKey = context.contentKey ?? context.exportId;
  return `${tool}:${context.format}:${contentKey}`;
}

export function createExportId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `export-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}